import { createContext, useContext, useReducer } from "react";
import { initialState, productTagReducer } from "../reducer/ProductTagReducer";

const ProductTagStateContext = createContext();
const ProductTagDispatchContext = createContext();

export const ProductTagProvider = ({ children }) => {
  const [state, dispatch] = useReducer(productTagReducer, initialState);

  return (
    <ProductTagStateContext.Provider value={state}>
      <ProductTagDispatchContext.Provider value={dispatch}>
        {children}
      </ProductTagDispatchContext.Provider>
    </ProductTagStateContext.Provider>
  )
}

export const useProductTagState = () => {
  const context = useContext(ProductTagStateContext);

  if (!context) throw Error('useProductTagState는 ProductTagProvider 내에서 사용해야 합니다.');
  return context;
}

export const useProductTagDispatch = () => {
  const context = useContext(ProductTagDispatchContext);

  if (!context) throw Error('useProductTagDispatch ProductTagProvider 내에서 사용해야 합니다.');
  return context;
}